
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

interface AnalyticsGraphProps {
  data: any[];
  xAxisKey: string;
  lineDataKey: string;
  lineName: string;
}

const AnalyticsGraph: React.FC<AnalyticsGraphProps> = ({
  data,
  xAxisKey,
  lineDataKey,
  lineName,
}) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xAxisKey} />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey={lineDataKey}
          name={lineName}
          stroke="#8884d8"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AnalyticsGraph;
